import { Prompt, withDefaultScopes, UserScope, ReservedResource, isArbitraryObject } from '@logto/js';
import { deduplicate } from '@silverhand/essentials';

/**
 * Normalize the Logto client configuration per the following rules:
 *
 * - Add default scopes (`openid`, `offline_access` and `profile`) if not provided.
 * - Add {@link ReservedResource.Organization} to resources if {@link UserScope.Organizations} is included in scopes.
 *
 * @param config The Logto client configuration to be normalized.
 * @returns The normalized Logto client configuration.
 */
const normalizeLogtoConfig = (config) => {
    const { prompt = Prompt.Consent, scopes = [], resources, ...rest } = config;
    return {
        ...rest,
        prompt,
        scopes: withDefaultScopes(scopes).split(' '),
        resources: scopes.includes(UserScope.Organizations)
            ? deduplicate([...(resources ?? []), ReservedResource.Organization])
            : resources,
    };
};
const isLogtoSignInSessionItem = (data) => {
    if (!isArbitraryObject(data)) {
        return false;
    }
    return ['redirectUri', 'codeVerifier', 'state'].every((key) => typeof data[key] === 'string');
};
const isLogtoAccessTokenMap = (data) => {
    if (!isArbitraryObject(data)) {
        return false;
    }
    return Object.values(data).every((value) => {
        if (!isArbitraryObject(value)) {
            return false;
        }
        return (typeof value.token === 'string' &&
            typeof value.scope === 'string' &&
            typeof value.expiresAt === 'number');
    });
};

export { isLogtoAccessTokenMap, isLogtoSignInSessionItem, normalizeLogtoConfig };
